function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { circularFontFamily, typography } from '@airwallex/global';
import { baseTheme } from './base';
var getTypography = typography.getTypography; // language/character-specific bits

export var en = _objectSpread(_objectSpread({}, baseTheme), {}, {
  fontFamily: {
    default: circularFontFamily
  },
  typography: getTypography({
    langKey: 'en'
  })
});
export var zh = _objectSpread(_objectSpread({}, baseTheme), {}, {
  fontFamily: {
    // todo: change to zh's preference
    default: circularFontFamily
  },
  typography: getTypography({
    langKey: 'zh'
  })
}); // if/when we introduce other languages with latin-like characters, they'd likely look like:
// export const fr = en;
// export const it = en;
// jp may reuse zh, as the characters have similar visual complexity
// export const jp = zh;
// arabic would likely have its own typography/theme
// export const ar: LocalizedTheme = {...}